module.exports = __webpack_public_path__ + "static/media/waypoint_r.7b16b033.svg";